import { forwardRef } from 'react';
import { cx } from '@linaria/atomic';
import { useThemeValues } from '../../../hooks';
import { Button } from '../../button/button.component';
import type { ButtonRef } from '../button-type';
import { SecondaryButtonStyles } from './secondary-button.styles';
import { SecondaryButtonProps } from './types';

/** @deprecated Instead, please use `<Button variant='secondary'>` from `@frontend/design-system` */
export const SecondaryButton = forwardRef<ButtonRef, SecondaryButtonProps>(
  ({ children, destructive, size = 'small', trackingId, type = 'button', className, ...rest }, ref) => {
    const styles = SecondaryButtonStyles.secondaryButton({ destructive, size });
    const theme = useThemeValues();

    return theme.name === 'spark' ? (
      <Button
        variant='secondary'
        type={type}
        size={size === 'tiny' ? 'large' : size}
        destructive={destructive}
        {...rest}
        className={className}
        ref={ref}
        data-trackingid={trackingId}
      >
        {children}
      </Button>
    ) : (
      <button className={cx(styles, className)} type={type} {...rest} ref={ref} data-trackingid={trackingId}>
        {children}
      </button>
    );
  }
);
